enum Routes {
  DEMURRAGE = "/demurrage",
  DEMURRAGE_YEAR = "/demurrage/:year"
}

export default Routes;
